import { useAdminGet } from '@reapitform/hooks'
import { AdminPdfField, IResponseWithPagination } from '../types'

export const ADMIN_PDF_FIELDS_QUERY_KEY = ['admin-pdf-fields']

/** Loads every PDF field mapping for a version (`GET …/versions/{ref}/pdf-fields`). */
export const useAdminPdfFields = (formReferenceID?: string, versionReferenceID?: string) => {
  const [result, loading, errorString, refresh] = useAdminGet<IResponseWithPagination<AdminPdfField>>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/pdf-fields?pageNumber=1&pageSize=2000`,
    retry: false,
    queryKeys: [...ADMIN_PDF_FIELDS_QUERY_KEY, formReferenceID ?? '', versionReferenceID ?? ''],
    fetchWhenTrue: [Boolean(formReferenceID), Boolean(versionReferenceID)],
  })

  return { data: result?._embedded ?? [], loading, errorString, refresh }
}
